import React from "react";

import { Trans } from "@lingui/react/macro";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

export interface BadgeProps extends TypographyProps {
  disabled?: boolean;
}

type BadgePropsWithoutChildren = Omit<BadgeProps, "children">;

const Badge = styled<React.FC<BadgeProps>>(({ disabled: _, ...props }) => (
  <Typography {...props} />
))(({ theme, disabled }) => ({
  fontSize: "11px",
  lineHeight: "normal",
  fontWeight: 500,
  color: disabled ? theme.palette.text.weak : theme.palette.text.med,
  backgroundColor: theme.palette.bg.chip.base,
  borderRadius: theme.corners.small,
  padding: `${theme.spaces.xxsmall} ${theme.spaces.xsmall}`,
}));

export const DefaultBadge = (props: BadgePropsWithoutChildren) => (
  <Badge {...props}>
    <Trans>Default</Trans>
  </Badge>
);

export const RecommendedBadge = (props: BadgePropsWithoutChildren) => (
  <Badge {...props}>
    <Trans>Recommended</Trans>
  </Badge>
);

export default Badge;
